import appConfig from "../config/app.config";
import { makeGetRequest, makePostRequest } from "./makeRequest";

const getPartnerRateContracts = async (partner) => {
  try {
    const query = partner ? `?partner=${encodeURIComponent(partner)}` : "";
    const response = await makeGetRequest(
      `${appConfig.apiUrl.partnerRateContracts}${query}`
    );
    return response.data;
  } catch (error) {
    return error?.response?.data || error?.response || error;
  }
};

const createPartnerRateContract = async (data) => {
  try {
    const response = await makePostRequest(
      `${appConfig.apiUrl.partnerRateContracts}/create`,
      data
    );
    return response.data;
  } catch (error) {
    return error?.response?.data || error?.response || error;
  }
};

const updatePartnerRateContract = async (data) => {
  try {
    const response = await makePostRequest(
      `${appConfig.apiUrl.partnerRateContracts}/update`,
      data
    );
    return response.data;
  } catch (error) {
    return error?.response?.data || error?.response || error;
  }
};

export {
  getPartnerRateContracts,
  createPartnerRateContract,
  updatePartnerRateContract,
};
